import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import { FormItemLayout } from 'client/ui/form/FormItem';
import { TextInputItem } from 'client/ui/form/input/TextInputItem';
import { FormDividerSpace } from 'client/ui/space/FormDividerSpace';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IPDNDIdANPRFormProps {
  layout: FormItemLayout;
}

export function PDNDIdANPRForm(props: IPDNDIdANPRFormProps) {
  const { layout } = props;
  const { t } = useTranslation();
  return (
    <>
      <FormDividerSpace
        title={t('verification.c020.form.idANPRSearch', 'Ricerca per ID ANPR')}
        layout={layout}
        style={{ marginTop: 0 }}
      />
      <TextInputItem
        name="search.idANPR"
        label={t('verification.c020.form.idANPRSearch.label.idANPR', 'ID ANPR')}
      />
    </>
  );
}
